import type { ReactElement } from 'react'

/**
 * Statuslabel voor gezondheidscontroles.
 *
 * Toegankelijkheid: kleur is nooit de enige drager van betekenis. Naast de kleur
 * staat er altijd een tekstlabel, en de vorm van de markering verschilt per
 * status (rond / ruit / vierkant), zodat het onderscheid ook zichtbaar is voor
 * wie kleuren niet of anders waarneemt, en in zwart-witafdrukken.
 */

export type BadgeStatus = 'ok' | 'degraded' | 'down'

/** Onbekende statuswaarden gelden als 'down': stil doorgaan verbergt een storing. */
export function toBadgeStatus(value: string): BadgeStatus {
  switch (value) {
    case 'ok':
    case 'up':
    case 'healthy':
      return 'ok'
    case 'degraded':
    case 'warn':
    case 'warning':
      return 'degraded'
    default:
      return 'down'
  }
}

export interface StatusBadgeProps {
  readonly status: BadgeStatus
  /** Vertaald label; de component bevat zelf geen user-facing tekst. */
  readonly label: string
}

export function StatusBadge({ status, label }: StatusBadgeProps): ReactElement {
  return (
    <span className="status-badge" data-status={status}>
      <span className="status-badge__mark" aria-hidden="true" />
      <span className="status-badge__label">{label}</span>
    </span>
  )
}
